export const roundedInputStyle = {
	height: 51,
	borderRadius: 50,
	padding: '14px 18px',
};
